/**
 * Language configuration for supported languages
 * Contains metadata for language display, formatting, and pluralization
 * Supported languages: German, English, Spanish, French, Italian, Portuguese, Dutch, Polish, Swedish, Norwegian, Danish, Finnish, Czech, Hungarian, Romanian, Greek, Indonesian
 */

export const SUPPORTED_LANGUAGES = [
  { code: 'de', name: 'Deutsch', nativeName: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano', flag: '🇮🇹' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português', flag: '🇵🇹' },
  { code: 'nl', name: 'Dutch', nativeName: 'Nederlands', flag: '🇳🇱' },
  { code: 'pl', name: 'Polish', nativeName: 'Polski', flag: '🇵🇱' },
  { code: 'sv', name: 'Swedish', nativeName: 'Svenska', flag: '🇸🇪' },
  { code: 'no', name: 'Norwegian', nativeName: 'Norsk', flag: '🇳🇴' },
  { code: 'da', name: 'Danish', nativeName: 'Dansk', flag: '🇩🇰' },
  { code: 'fi', name: 'Finnish', nativeName: 'Suomi', flag: '🇫🇮' },
  { code: 'cs', name: 'Czech', nativeName: 'Čeština', flag: '🇨🇿' },
  { code: 'hu', name: 'Hungarian', nativeName: 'Magyar', flag: '🇭🇺' },
  { code: 'ro', name: 'Romanian', nativeName: 'Română', flag: '🇷🇴' },
  { code: 'el', name: 'Greek', nativeName: 'Ελληνικά', flag: '🇬🇷' },
  { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia', flag: '🇮🇩' },
];

/**
 * Get language metadata by code
 * @param {string} code - Language code
 * @returns {object|null} Language metadata or null if not found
 */
export const getLanguageByCode = (code) => {
  return SUPPORTED_LANGUAGES.find(lang => lang.code === code.toLowerCase()) || null;
};

/**
 * Get all language codes
 * @returns {string[]} Array of language codes
 */
export const getLanguageCodes = () => {
  return SUPPORTED_LANGUAGES.map(lang => lang.code);
};

/**
 * Check if a language code is supported
 * @param {string} code - Language code to check
 * @returns {boolean} True if supported
 */
export const isLanguageSupported = (code) => {
  return SUPPORTED_LANGUAGES.some(lang => lang.code === code.toLowerCase());
};

/**
 * Get default language (German)
 * @returns {string} Default language code
 */
export const getDefaultLanguage = () => {
  return 'de';
};

/**
 * Get fallback language (German)
 * @returns {string} Fallback language code
 */
export const getFallbackLanguage = () => {
  return 'de';
};

/**
 * Create language object for translation system
 * @returns {object} Language object with all supported languages
 */
export const getLanguagesForTranslations = () => {
  const languages = {};
  SUPPORTED_LANGUAGES.forEach(lang => {
    languages[lang.code] = lang.nativeName;
  });
  return languages;
};

